export default[
    {
        path: '/backup',
        name: 'backup', 
        component: () => import(/* webpackChunkName: "Login" */ './page/index.vue')
    },
]